
import * as React from 'react';
import { Box, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Calendar } from 'lucide-react';
import dayjs, { Dayjs } from 'dayjs';

interface DateInputProps {
    label: string;
    value: string;
    onChange: (value: string) => void;
    minDate?: string;
}

const DateInput: React.FC<DateInputProps> = ({ label, value, onChange, minDate }) => {
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef<HTMLDivElement>(null);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75, width: 180 }}>
            <Typography sx={{ fontSize: 12, fontWeight: 600, color: 'var(--color-text-muted)', textTransform: 'uppercase', letterSpacing: 0.4 }}>
                {label}
            </Typography>
            <Box
                ref={anchorRef}
                onClick={() => setOpen(true)}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    border: '1.5px solid #E0E3E5',
                    borderRadius: 2,
                    padding: '10px 14px',
                    cursor: 'pointer',
                    background: 'var(--color-container-background)',
                    transition: 'border-color 0.15s ease',
                    '&:hover': { borderColor: 'var(--color-primary)' },
                }}
            >
                <Calendar size={18} color="var(--color-primary)" style={{ flexShrink: 0 }} />
                <Typography sx={{ fontSize: 15, fontWeight: 600, color: value ? 'var(--color-default-text)' : '#B3B3B3' }}>
                    {value ? dayjs(value).format('MM/DD/YY') : 'mm/dd/yy'}
                </Typography>
            </Box>
            <DatePicker
                open={open}
                onClose={() => setOpen(false)}
                value={value ? dayjs(value) : null}
                onChange={(value, _context) => {
                    const date = dayjs.isDayjs(value) ? value : (value ? dayjs(value) : null);
                    onChange(date ? date.format('YYYY-MM-DD') : '');
                    setOpen(false);
                }}
                format="MM/DD/YY"
                minDate={minDate ? dayjs(minDate) : undefined}
                enableAccessibleFieldDOMStructure={false}
                slots={{ textField: () => null }}
                slotProps={{
                    popper: {
                        anchorEl: anchorRef.current,
                    },
                }}
            />
        </Box>
    );
};

export default DateInput;
